import React, {  } from "react";
import { useStores } from "../../store";
import { EnrollForCourses } from "./dashboard";
import { useNavigate } from "react-router-dom";
import { FaPlayCircle } from "react-icons/fa";
export function EnrolledCoursesProgressBar1({ onCLickEmptyEnroll }) {
  const { LearningStore } = useStores();
  const navigate = useNavigate();

  return (
    <div>
      <div className="mt-1 my-3 md:mx-8  lg:mx-8 w-[100%] ">
        <div className=" flex  py-3 px-0 md:px-0 lg:px-4 overflow-x-auto ml-[2rem] md:ml-0 no-scrollbar space-x-4 lg:space-x-10  w-[100%] mx-0">
          {LearningStore.enrolledCourses.length === 0 && (
            <EnrollForCourses
              onClick={() => {
                if (onCLickEmptyEnroll) {
                  return onCLickEmptyEnroll();
                }
              }}
            />
          )}
          {LearningStore.enrolledCourses
            .slice()
            .sort((a, b) => b.createdAt - a.createdAt)
            .map((enroll, index) => (

              <Progress_bar
              
              label = {enroll?.course?.title}
                score = {LearningStore.getTheCourseCompletionPercentage(
                  enroll?.course?._id
                )}
                image = {enroll?.course?.image}
                key= {index}
                id= {enroll?.course?._id}
                // Assigning a random color from the array
                color= {getRandomColor(index)}
                font= {getRandomFont(index)}

               />
              
              
            ))}
        </div>
      </div>
    </div>
  );
}

// Function to get a random color from an array
function getRandomColor(index) {
  const colors = ["#f4f2ff", "#fff2ec", "#ecfbff"];
  const randomIndex = index % colors.length;
  return colors[randomIndex];
}

function getRandomFont(index) {
  const fonts = ["#8f7eed", "#ff5e18", "#0093cd"];
  const randomFontIndex = index % fonts.length;
  return fonts[randomFontIndex];
}

export function Progress_bar({ label, image, score, id, color, font }) {
  console.log(label, image, score, id, color, font);
  const navigate = useNavigate();
  const isPointerVisible = score > 0;
  const goToCourseById = (id) => {
    if (window.innerWidth > 768) {
      navigate(`/dashboard/course/${id}`);
    } else {
      navigate(`/course/${id}`);
    }
  };
  console.log("color");
  console.log(color);
  console.log("font");
  console.log(font);

  return (
    <div
      style={{ backgroundColor: color }}
      className="h-48 w-60 lg:h-96 lg:w-96 mx-0 lg:m-6 l mb-4 lg cursor-pointer border rounded-2xl  bg-${color}"
      onClick={() => goToCourseById(id)}
    >
      <div className="p-4 px-6  lg:pb-6">
        <img
          src={image}
          className="h-[50px] w-[50px] lg:h-[100px] lg:w-[100px]  object-cover  rounded-full"
        />
      </div>
      <div 
      style={{ color: font }}
      className="overflow-y-hidden text-${font}">
        <p className=" mx-5 gil-bold opacity-80 pb-2 lg:pb-8 overflow-y-hidden h-12 lg:text-xl lg:h-16 ">
          {label}
        </p>
      </div>
      {/* <div className="pt-3">
      <div className="flex gap-1 ml-3 w-56 lg:w-96 text-xs lg:mt-2 lg:px-4 lg:text-xl font-bold pb-2 px-2 opacity-50">
        <span>Present Topic :-  </span>
        <div style={{ color: font }}
        className=" text-${font}"
        >
        <span>--------</span>
        </div>
      </div>
      <div className="flex gap-1 ml-3 text-xs lg:text-xl lg:pb-4 lg:px-4 font-bold pb-2 px-2 opacity-50">
        <span>Next Topic :-  </span>
        <div style={{ color: font }}
        className=" text-${font}"
        >
        <span>-------</span>
        </div>
      </div>
      </div> */}
      
      <div className="flex items-center px-1 w-56 lg:w-96">
        <div className="w-[90%] h-[4px] lg:h-[6px] rounded-full mx-3 my-1 bg-white relative">
          <div
            className="bg-primary h-full rounded-full lg:text-xl"
            style={{ width: `${score}%` }}
          ></div>
          {isPointerVisible && (
            <div
              className="bg-primary w-4 h-4 rounded-full absolute top-1/2 -translate-y-1/2 right-0 transform"
              style={{ right: `calc(${100 - score}% - 2px)` }}
            ></div>
          )}
        </div>
      </div>
      <div
      style={{ color: font }}
      className="flex items-center text-${font}">
        <p className="mx-3 mb-1 gil-bold text-xs lg:text-xl lg:pt-4 pt-2 px-2 opacity-80">
          {score}% Completed
        </p>
        <FaPlayCircle className="pt-1 text-xl text-black" />
      </div>
    </div>
  );
}
